import { ALERT_SEVERITY } from '../../util/constants';
import { showAlert } from './slices';

export const showErrorAlert = (message, title = 'Error') => (dispatch) => {
  dispatch(showAlert({ 
    severity: ALERT_SEVERITY.ERROR, 
    title, 
    message, 
    autoHide: false 
  }));
};

export const showInfoAlert = (message, title = 'Info') => (dispatch) => {
  dispatch(showAlert({ 
    severity: ALERT_SEVERITY.INFO, 
    title, 
    message 
  }));
};

export const showSuccessAlert = (message, title = 'Success') => (dispatch) => {
  dispatch(showAlert({ 
    severity: ALERT_SEVERITY.SUCCESS, 
    title, 
    message 
  }));
};


export const showWarningAlert = (message, title = 'Warning') => (dispatch) => {
  dispatch(showAlert({ 
    severity: ALERT_SEVERITY.WARNING, 
    title, 
    message 
  }));
};
